import { render, staticRenderFns } from "./AddHP.vue?vue&type=template&id=780c08b1&"
import script from "./AddHP.vue?vue&type=script&lang=js&"
export * from "./AddHP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports